import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { fontSize } from "@/utils/font";

import axios from "@/utils/request"
Vue.prototype.$http = axios
Vue.prototype.$fontSize = fontSize

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
